import React, { createContext, useContext, useMemo } from 'react';
/**
 * @internal
 */
export var initialContextValue = { value: 0, id: 0 };
export var SSRContext = createContext(initialContextValue);
/**
 * Provider that synchronizes the layout data when the application is hydrated.
 *
 * @example
 * const Root = () => (
 *   <SSRProvider>
 *     <App />
 *   </SSRProvider>
 * )
 */
export var SSRProvider = function (_a) {
    var children = _a.children;
    var context = useContext(SSRContext);
    var value = useMemo(function () {
        return {
            value: 0,
            id: context === initialContextValue ? 0 : ++context.id,
        };
    }, [context]);
    return React.createElement(SSRContext.Provider, { value: value }, children);
};
